import getApiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const postProjectAssignment = (
    backend: string,
    token: string,
    project_id: number,
    task_id: number,
    created_by_id: number,
    description?: any,
    sales_price?: any,
    cost_price?: any,
    estimated_hours?: any,
    quantity?: any,
    unhandledQuantity?: any,
    toInvoiceQuantity?: any,
    discount?: any,
    active?: any,
    id?: any,
) => {
    return fetch(
        
        `${getApiUrl(backend)}assignments${id ? '/' + id : ''}`,
        {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                active: active === 0 ? 0 : 1,
                project_id,
                task_id,
                created_by_id,
                changed_by_id: created_by_id,
                description,
                sales_price,
                cost_price,
                estimated_hours,
                quantity,
                unhandledQuantity,
                toInvoiceQuantity,
                discount,
            })
        }
    );
};

export default postProjectAssignment;
